"use client";

import { Play } from "lucide-react";
import { images } from "@/config/images";
import Image from "next/image";
import { Headline6 } from "@/components/typography";

export function FounderVideoSection() {
  const handlePlayVideo = () => {
    window.open(images.founder.videoUrl, "_blank");
  };

  return (
    <section className="w-full bg-white py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div
          className="relative w-full aspect-[9/16] md:aspect-[21/9]"
          onClick={handlePlayVideo}
        >
          {/* Background Images */}
          {/* Desktop Image */}
          <Image
            src={images.founder.thumbnailDesktop}
            alt="Spicenet Founder Video"
            fill
            className="hidden md:block object-cover"
            priority
          />
          {/* Mobile Image */}
          <Image
            src={images.founder.thumbnailMobile}
            alt="Spicenet Founder Video"
            fill
            className="block md:hidden object-cover"
            priority
          />

          {/* Content Overlay */}
          <div className="absolute inset-0 container mx-auto px-4 md:px-6 max-w-7xl">
            <div className="relative h-full flex items-start md:items-center">
              {/* Content positioned at top on mobile, left on desktop */}
              <div className="w-full md:w-auto pt-8 md:pt-0 md:pb-0 md:pl-8 space-y-4 md:space-y-6 max-w-lg">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-[-1.5px] text-white">
                  The Spicy
                  <br />
                  Future of DeFi
                </h2>
                <Headline6 className="text-xs md:text-sm  text-white/70 ">
                  Learn about Spicenet from our co-founder Matt McConnell.
                </Headline6>
                <button
                  onClick={handlePlayVideo}
                  className="flex items-center gap-3 text-spicenet-primary hover:text-spicenet-primary/80 transition-colors duration-200 group"
                >
                  <div className="w-16 h-16 rounded-full border-2 border-spicenet-primary flex items-center justify-center group-hover:border-spicenet-primary/80 transition-colors duration-200">
                    <Play
                      className="w-6 h-6 fill-spicenet-primary ml-1"
                      strokeWidth={0}
                    />
                  </div>
                  <span className="text-sm uppercase tracking-wider font-medium tracking-[-1.5px]">
                    Play Video
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
